import { Directive, ElementRef, Input, Renderer2, OnChanges, OnInit, Output, EventEmitter } from '@angular/core'
import { WrapMiddleService } from '../services/wrap-middle/wrap-middle.service'

@Directive({
  selector: '[wrapMiddle]'
})
export class WrapMiddleDirective implements OnInit, OnChanges {
  @Input('wrapMiddle') text: string
  @Input() iconClass: string | undefined;
  @Output() iconClick = new EventEmitter<void>();

  constructor(private el: ElementRef, private renderer: Renderer2, private service: WrapMiddleService) {}

  ngOnInit() {
    if (this.iconClass) {
      const iconElement = this.el.nativeElement.querySelector('.metric-icon');
      if (iconElement) {
        this.renderer.listen(iconElement, 'click', () => {
          this.iconClick.emit();
        });
      }
    }
  }

  ngOnChanges() {
    const wrapped = this.service.wrapString(this.text)
    if (wrapped.includes('\n')) {
      this.setText(wrapped.replace(/\n/g, '<br>'))
      this.renderer.addClass(this.el.nativeElement, 'wrapped')
    } else {
      this.setText(this.text)
    }
  }

  setText(s) {
    const iconHTML = this.iconClass ? `<i style="color: rgba(0, 0, 0, 0.6); cursor: pointer;" class="${this.iconClass} metric-icon"></i>` : '';
    const text = `${iconHTML} ${s}`;
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', text);
  }
}
